import React from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';

interface Props {
	notification: any;
	orderNumber: number;
	closeNotification: (identifier: number) => void;
}

const RedBox = styled.div<{ orderNumber: number, displayStyle: string }>`
	position: fixed;
	top: ${(props) => props.orderNumber * 4}rem;
	left: 0;
	min-height: 4rem;
	padding: 19px;
	font-size: 19px;
	z-index: 1000;
	box-shadow: 3px 0 3px #999;
	border: 1px solid #fafafa;
	width: 100%;
	text-align: center;
	background-color: ${(props) => props.displayStyle};
	display: flex;
	align-items: flex-start;
	justify-content: center;
	
	.message {
		padding-right: 35px;
	}
	
	@media screen and (min-width: 768px) {
		padding: 16px 40px;
		font-size: 24px;
	}
`;

const IconWrapper = styled.span`
	padding-right: 0.4rem;
	span {
		transform: scale(.8);
		margin-top: -4px;
	}
`;

const CloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 100%;
	height: 25px;
	width: 25px;
	border: 2px solid #666;
	position: absolute;
	right: 20px;
	top: 20px;
	cursor: pointer;
	
	.svg-icon {
		transform: scale(.7);
	}

	@media screen and (min-width: 768px) {
		height: 28px;
		width: 28px;

		.svg-icon {
			transform: scale(.9);
		}
	}
`;

export const Notification: React.FC<Props> = (props: Props) => (
	<div>
		{props.notification && (
			<RedBox orderNumber={props.orderNumber} displayStyle={props.notification.displayStyle === 'red-box' ? 'hsl(0, 100%, 98%)' : 'white'}>
				<IconWrapper>
					<Icon name="small--alert"/>
				</IconWrapper>
				<div className={'message'}>{props.notification.message}</div>
				<CloseButton onClick={() => props.closeNotification(props.notification.identifier)}>
					<Icon name="small--x--black"/>
				</CloseButton>
			</RedBox>
		)}
	</div>
);